import { LoaderFunction, useFetcher } from "react-router-dom";
import { getActiveAssets } from "../../../common/api/decimal/methods/license.ts";
import { getRecentAssets } from "../../../common/api/bridge/methods.ts";
import { DecimalResult } from "../../../common/api/decimal/utils.ts";
import { ManageAssetWithLicense } from "../../../common/api/decimal/common-types/manageAssets.ts";

type ExploreVbidMap = Record<string, VST.Bridge.Asset>;
const emptyExploreArray: VST.Bridge.Asset[] = [];
const emptyExploreMap: ExploreVbidMap = {};

type LoaderResult = DecimalResult<ManageAssetWithLicense[]>;

export const libraryLoader: LoaderFunction = async ({
  params,
}): Promise<LoaderResult | undefined> => {
  if (params.page) {
    const intPage = parseInt(params.page, 10);
    return getActiveAssets(intPage);
  }
};

export function useLibraryFetcher() {
  return useFetcher<LoaderResult>();
}

export const loadRecentExploreAssets: LoaderFunction =
  (): Promise<ExploreVbidMap> => {
    return getRecentAssets()
      .then((response) => {
        if (response.status === 200) {
          return response.lists[0]?.content ?? emptyExploreArray;
        }
        return emptyExploreArray;
      })
      .catch(() => emptyExploreArray)
      .then((assets) =>
        assets.reduce((acc, asset) => {
          acc[asset.vbid] = asset;
          return acc;
        }, emptyExploreMap)
      );
  };

export function useLibraryExploreFetcher() {
  return useFetcher<ExploreVbidMap>();
}
